export const formatBytes = (bytes: number) => {
  if (!bytes) return "0b";

  const k = 1024;

  const sizes = ["b", "kb", "mb", "gb", "tb", "pb"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + sizes[i];
};
